// Oturum belgesinin (X-Session-Token) tarayıcı tarafı kontrolü: imza sunucuda doğrulanır,
// burada yalnız biçim ve son kullanma zamanı okunur (süresi dolmuş belgeyle oturum açık tutulmaz).
const b64urlDecode = (s: string) => {
  const p = s.replace(/-/g, '+').replace(/_/g, '/');
  return atob(p + '==='.slice((p.length + 3) % 4));
};

/** Belge var, biçimi doğru ve en az `marginMs` daha geçerli mi */
export function isSessionTokenUsable(token: string | null | undefined, now = Date.now(), marginMs = 60_000): boolean {
  if (!token) return false;
  const [payload, sig] = token.split('.');
  if (!payload || !sig) return false;
  try {
    const claims = JSON.parse(b64urlDecode(payload));
    return typeof claims.exp === 'number' && claims.exp > now + marginMs && !!claims.tenantId;
  } catch {
    return false;
  }
}

export const SESSION_NOTICE_KEY = 'sessionReloginNotice';
/** Ücretsiz pakette patron dışı oturum kapatıldı: giriş ekranı "yalnız patron" uyarısını gösterir */
export const PLAN_FREE_ROLE_NOTICE_KEY = 'planFreeOnlyPatronNotice';

/**
 * Oturumu kapatıp giriş ekranına gönderir; giriş ekranı bir kez açıklama gösterir.
 * `noticeKey` verilmezse "güvenlik güncellemesi" açıklaması.
 */
export function forceRelogin(noticeKey: string = SESSION_NOTICE_KEY): void {
  try {
    localStorage.removeItem('user');
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('branchId');
    localStorage.setItem(noticeKey, '1');
  } catch { /* */ }
  if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
    window.location.href = '/login';
  }
}
